
//Agregar multiidioma

const Loading = () => {
    return (
        <div className="Loading">
            <p className="spinner-border text-light" role="status"><span className="visually-hidden">Cargando...</span></p>
            <p>Cargando...</p>
        </div>
    )
}

export { Loading };